// extracted by mini-css-extract-plugin
export default {"container":"SideSheet_container__VQbQV","wrapper":"SideSheet_wrapper__XvveK","content":"SideSheet_content__Bnh5e"};